module.exports = __webpack_public_path__ + "img/Option Chain.530dc0b9.svg";